module.exports = __webpack_public_path__ + "static/closeup-ed91ea0a77aad53ca4c8dc357b7f681f.webp";